import React, { FC, useCallback, useState } from 'react';

import { useIntl } from 'react-intl';

import useErrorModal from 'hooks/use-error-modal';
import { ILoyaltyCategoryOption } from 'state/loyalty/types';

import { RewardTierSelectionModal } from '../reward-tier-selection-modal';

import { useLoyaltyCategories } from './use-loyalty-categories';
import { useSelectedReward } from './use-selected-reward';

type SelectedRewardTierIdType = string | null | undefined;

export type IUseRewardSelectionModal<P = any> = [
  React.FC<P>,
  {
    onChangeRewardTier: (tierId: string | null) => Promise<void>;
    openRewardsModal: () => void;
    selectedRewardCategoryId?: string;
    selectedRewardTier?: ILoyaltyCategoryOption;
    selectedRewardTierId: SelectedRewardTierIdType;
    updatingRewardTier: boolean;
  }
];

export function useRewardSelectionModal<P = {}>(): IUseRewardSelectionModal<P> {
  const { formatMessage } = useIntl();
  const loyaltyCategories = useLoyaltyCategories();

  const [showRewardSelectionModal, setShowhowRewardSelectionModal] = useState(false);

  const openRewardsModal = useCallback(() => {
    setShowhowRewardSelectionModal(true);
  }, [setShowhowRewardSelectionModal]);
  const closeRewardsModal = useCallback(() => setShowhowRewardSelectionModal(false), [
    setShowhowRewardSelectionModal,
  ]);

  const [ErrorDialog, openErrorDialog] = useErrorModal({
    modalAppearanceEventMessage: 'Error: Setting Reward Tier Failure',
  });

  const onSetRewardsTierError = useCallback(
    () => openErrorDialog({ message: formatMessage({ id: 'setRewardsTierError' }) }),
    [formatMessage, openErrorDialog]
  );

  const {
    onChangeRewardTier,
    selectedRewardCategoryId,
    selectedRewardTier,
    selectedRewardTierId,
    updatingRewardTier,
  } = useSelectedReward(loyaltyCategories, { onSetRewardsTierError });

  const RewardSelectionModal: FC = () => {
    return (
      <>
        {showRewardSelectionModal && (
          <RewardTierSelectionModal
            onDismiss={closeRewardsModal}
            radioButtonName="change-reward-level-modal-reward-tier"
            onChangeRewardTier={onChangeRewardTier}
            selectedRewardTierId={selectedRewardTierId}
            selectedRewardCategoryId={selectedRewardCategoryId}
          />
        )}
        <ErrorDialog />
      </>
    );
  };

  return [
    RewardSelectionModal,
    {
      onChangeRewardTier,
      openRewardsModal,
      selectedRewardCategoryId,
      selectedRewardTier,
      selectedRewardTierId,
      updatingRewardTier,
    },
  ];
}
